import { Text, TextField } from "@merge-api/merge-javascript-shared";
import { useEffect, useState } from "react";

export interface CappedNumberFieldProps {
  label: string;
  description: string;
  placeholder?: string;
  value: number | undefined;
  max: number;
  capErrorMessage: string;
  onChange: (value: number | undefined) => void;
  onErrorChange?: (isError: boolean) => void;
  errorText?: string;
}

const CappedNumberField = ({
  label,
  description,
  placeholder,
  value,
  max,
  capErrorMessage,
  onChange,
  onErrorChange,
  errorText,
}: CappedNumberFieldProps) => {
  const [inputValue, setInputValue] = useState<string>(
    value === undefined || value === null ? "" : String(value)
  );

  useEffect(() => {
    // Sync local state if value prop changes from outside
    if (value === undefined || value === null) {
      setInputValue("");
    } else if (String(value) !== inputValue) {
      setInputValue(String(value));
    }
  }, [value]);

  const isMissingOrZero = value === undefined || value === null || value === 0;
  const isError = isMissingOrZero || (typeof value === "number" && value > max);

  useEffect(() => {
    onErrorChange?.(isError);
  }, [isError, onErrorChange]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setInputValue(val);
    if (val === "") {
      onChange(undefined as any);
      return;
    }
    const num = Number(val);
    if (!isNaN(num)) {
      onChange(num);
    }
  };

  return (
    <div>
      <Text variant="h6">{label}</Text>
      <Text as="div" className="text-gray-40 mb-2">
        {description}
      </Text>
      <TextField
        type="number"
        placeholder={placeholder ?? label}
        value={inputValue}
        onChange={handleChange}
        error={isError}
        errorText={isError ? errorText ?? capErrorMessage : undefined}
      />
    </div>
  );
};

export default CappedNumberField;
